export default __webpack_public_path__ + "eb7d3e1aa705dee845d74d33c1a681fc.png";